import Immutable from 'immutable';

export interface RawStudioProjectFile {
  id: number;
  name: string;
  path: string;
  parentfolderid: number;
  permission: string;
  created: string;
  size: number;
  isLocked: boolean;
  inSession: boolean;
  revisionID: number;
  studioprojectid: string;
}

export interface StudioProjectFileData {
  id: number;
  name: string;
  path: string;
  parentfolderid: number;
  permission: string;
  created: string;
  size: number;
  isLocked: boolean;
  inSession: boolean;
  revisionID: number;
  studioprojectid: string;
}

const defaultFileValues: StudioProjectFileData = {
  id: 0,
  name: '',
  path: '',
  parentfolderid: 0,
  permission: '',
  created: '',
  size: 0,
  isLocked: false,
  inSession: false,
  revisionID: 0,
  studioprojectid: '',
};

export const StudioProjectFileFactory = Immutable.Record(
  defaultFileValues,
  'StudioProjectFile'
);

export class StudioProjectFile extends StudioProjectFileFactory {
  static deserialize(rawStudioFile: RawStudioProjectFile): StudioProjectFile {
    return new StudioProjectFile({
      ...rawStudioFile,
    });
  }
}
